import { DateTime } from "luxon";
import { extractTimeFromDate } from "./common";

/**
 * Geriye array içerisinde name,value döndürür
 * @param {import("react").ChangeEvent<any>} event
 * @returns {[string,string|number|object|Array]}
 */
export function getKeyValueFromEvent(event) {
  console.log(event)
  const name =
    event.target.name ||
    event.target.element?.name ||
    event.target.element?.current?.name ||
    event.target.props?.name;
  let value = undefined;
  if (
    event.target.element &&
    Object.getOwnPropertyDescriptor(event.target.element, "checked")
  ) {
    value = event.target.element.checked;
  }
  if (Object.getOwnPropertyDescriptor(event.target, "checked")) {
    value = event.target.value;
  } else if (Object.getOwnPropertyDescriptor(event, "value")) {
    if (event.value && Array.isArray(event.value)) {
      value = event.value;
    } else {
      value = event.target.props?.dataItemKey
        ? event.value[event.target.props.dataItemKey]
        : event.value;
    }
  } else if (
    Object.getOwnPropertyDescriptor(event.target, "value") ||
    typeof event.target?.value === "string"
  ) {
    if (event.target.type === "number") {
      if (event.target.value) value = +event.target.value;
      else {
        value = event.target.value;
      }
    } else {
      value = event.target.value;
    }
  } else if (
    event.target.element &&
    Object.getOwnPropertyDescriptor(event.target.element, "value")
  ) {
    value = event.target.element.value?.id || event.target.element.value;
  } else if (
    event.target.element?.current &&
    Object.getOwnPropertyDescriptor(event.target.element?.current, "value")
  ) {
    value =
      event.target.element.current.value?.id ||
      event.target.element.current.value;
  }
  if ("html" in event) {
    value = event.html;
  }
  if (
    event.target.props &&
    Object.getOwnPropertyDescriptor(event.target.props, "data")
  ) {
    if (
      event.target.props.data?.length > 0 &&
      (event.nativeEvent.type === "keydown" ||
        event.nativeEvent.type === "click")
    ) {
      //test
    }
  }
  if (value instanceof Date) {
    if ("_dateTimeSelector" in event.target) {
      value = DateTime.fromJSDate(value).toISO();
    } else if ("_timeSelector" in event.target) {
      value = extractTimeFromDate(value);
    } else if ("_dateInput" in event.target) {
      value = DateTime.fromJSDate(value).toFormat("dd-MM-yyyy");
    }
  }

  return [name, value];
}
